import * as Yup from "yup";
const tabelaVendaItemValidator = Yup.object().shape({
  produto: Yup.mixed()
    .required("Selecione um produto para adicionar")
    .test(
      "is-object",
      "Produto deve ser um objeto válido",
      (value) => value && typeof value === "object"
    ),
  fator: Yup.number().nullable().required("Fator"),
  quantidadeMinima: Yup.number().nullable().required("Quantidade Mínima"),
  precoPraticado: Yup.number().nullable().required("Preço praticado"),
});

export default tabelaVendaItemValidator;
